export default "__VITE_ASSET__BnteBMon__"